import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAppSelector } from "../store/hooks";

type Props = { children: React.ReactNode };

const AdminRoute = ({ children }: Props) => {
  const location = useLocation();
  const user = useAppSelector(state => state.auth.user);
  const isAdmin = user?.role === 'ADMIN';

  return isAdmin ? (
    <>{children}</>
  ) : (
    <Navigate to="/dashboard" state={{ from: location }} replace />
  );
};

export default AdminRoute;
